<template>
    <section :class="[{'ArticleContent_noContent':isContentEmpty}]" class="ArticleContent Article" v-if="currentArticle">
        <debugArticleDisplay :article="currentArticle"></debugArticleDisplay>

        <!--
        Image Thumbnail
        -->
        <figure class="ArticleContent-media ArticleContent-media_image ArticleMedia ArticleMedia_image" v-if="currentArticle.preview.image && !currentArticle.preview.video">
            <img :src="currentArticle.preview.image.url" class="ArticleMedia-image">
        </figure>


        <!--
        Video Thumbnail
        -->
        <figure class="ArticleContent-media ArticleContent-media_video ArticleMedia ArticleMedia_video" v-if="currentArticle.preview.video">
            <div class="ArticleMediaVideo-loading modal modal-on LoadingSpinner">
                <div class="LoadingSpinner-spinner LoadingSpinner-spinner_loading"></div>
            </div>
            <img :src="videoThumb" class="ArticleMediaVideo-preview">
            <vue-plyr :emit="[
						'ready',
						'beforeDestroy'
					]"
                    @beforeDestroy="videoDestroy"
                    @ready="videoIsReady"
                    v-if="currentArticle.preview.video.provider !== ''"
            >
                <div :data-plyr-embed-id="currentArticle.preview.video.id"
                        :data-plyr-provider="currentArticle.preview.video.provider"
                        class="ArticleMediaVideo-player"
                        data-plyr-config='{
					"title": "",
					"volume": 1,
					"rel": 0,
					"debug": false,
					"mute": 1,
					"autoplay": 0,
					"resetOnEnd": 1,
					"storage": { "enabled": true, "key": "relmplyr" },
					"controls": ["play-large", "play", "progress", "current-time", "mute", "volume", "fullscreen"]
				}'></div>
            </vue-plyr>
        </figure>


        <!--
        Empty Space to show title nicely
        -->
        <div class="ArticleContent-media ArticleContent-media_noPreviewMedia ArticleMedia ArticleMedia_noPreviewMedia" v-if="!isContentEmpty && !currentArticle.preview.image && !currentArticle.preview.video">

        </div>


        <!--
        Titles and Subtitle
        -->
        <header :class="[
        {'ArticleContent-header_noPreviewMedia':!currentArticle.preview.video && !currentArticle.preview.image},
        {'ArticleContent-header_noContent':isContentEmpty},
        {'ArticleContent-header_video':currentArticle.preview.video !== undefined},
        {'ArticleContent-header_image':currentArticle.preview.image}
        ]" class="custom-ArticleContent-header ArticleContent-header ArticleHeader" v-if="currentArticle.title || currentArticle.subtitle">
            <h2 class="custom-ArticleHeader-title ArticleHeader-title" v-if="currentArticle.title">{{ currentArticle.title }}</h2>
            <h3 class="custom-ArticleHeader-subtitle ArticleHeader-subtitle" v-if="currentArticle.subtitle">{{ currentArticle.subtitle }}</h3>
        </header>


        <!--
        Main text
        -->
        <main class="custom-ArticleContent-main ArticleContent-main ArticleMain" v-html="currentArticle.content" v-if="!isContentEmpty"></main>
    </section>
</template>


<script>
    import store from '@/store';
    //const _ = require('lodash')

    export default {
        name: 'ArticleFullContent',
        components: {
            'debugArticleDisplay': () => import('@/components/debugArticleDisplay'),
            'ArticleNavPrevious': () => import('@/components/ArticleNavPrevious'),
            'ArticleNavNext': () => import('@/components/ArticleNavNext')
        },
        data() {
            return {
                videoOptions: {
                    'title': 'test'
                },
                videoContainerClass: 'ArticleContent-media_video'
            };
        },
        computed: {
            currentArticle: () => {
                return store.state.currentArticle;
            },
            videoThumb() {
                const highRes = this.currentArticle.preview.video.urls.raw;
                const fallback = this.currentArticle.preview.video.urls.regular;
                const img = new Image();
                img.src = highRes;
                return (img.naturalWidth > 120) ? highRes : fallback;
            },
            isContentEmpty() {
                return (this.currentArticle.content.replace(/<[^>]*>/g, '').length === 0);
            }
        },
        async mounted() {
            await this.applyClasses();
        },
        methods: {
            videoIsReady() {
                let videoReadyTimeout = setTimeout(() => {
                    let videoContainer = document.querySelector('.' + this.videoContainerClass);
                    if (videoContainer) {
                        videoContainer.classList.add(this.videoContainerClass + '_ready');
                        let videoFrame = videoContainer.getElementsByTagName('iframe')[0];
                        videoFrame.removeAttribute('title');
                    }
                    clearTimeout(videoReadyTimeout);
                }, 250);
            },
            videoDestroy() {
                let videoContainer = document.querySelector('.' + this.videoContainerClass);
                if (videoContainer) {
                    videoContainer.classList.remove(this.videoContainerClass + '_ready');
                }
            },
            eventOver: (el, className) => {
                el.classList.add(className);
            },
            eventOut: (el, className) => {
                el.classList.remove(className);
            },
            applyClasses() {
                let vm = this;
                let elMain = document.getElementsByClassName('ArticleMain')[0];
                if (elMain !== undefined) {
                    elMain.querySelectorAll('a').forEach((el) => {
                        el.addEventListener('mouseover', function () {
                            vm.eventOver(el, 'custom-a_hover', 'a_hover');
                        });
                        el.addEventListener('mousemove', function () {
                            vm.eventOver(el, 'custom-a_hover', 'a_hover');
                        });
                        el.addEventListener('mouseout', function () {
                            vm.eventOut(el, 'custom-a_hover', 'a_hover');
                        });
                    });
                }
            }
            /*
            videoTimeUpdated () {
                console.log('videoTimeUpdated');
            },
            videoEnterFullScreen (e) {
                console.log('videoEnterFullScreen', e);
            },
            videoExitFullScreen (e) {
                console.log('videoExitFullScreen', e);
            },
            videoClose (e) {
                console.log('videoClose', e);
            }
            */
        }
    };
</script>
